import { render, staticRenderFns } from "./c_competitions.vue?vue&type=template&id=6c6ff311&scoped=true"
import script from "./c_competitions.vue?vue&type=script&lang=js"
export * from "./c_competitions.vue?vue&type=script&lang=js"
import style0 from "./c_competitions.vue?vue&type=style&index=0&id=6c6ff311&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ff311",
  null
  
)

export default component.exports